/* eslint-disable */

import modal from './vendors/modal.js';

export default () => {
    window.addEventListener('load', () => {

        const openHcpModal = () => {
            let el__trigger = document.getElementById('autoload-trigger');
            modal.open(el__trigger);
            document.querySelector('#hcpGateway-modal button.modal__confirm').addEventListener('click', (e) => {
                sessionStorage.setItem('confirmedHcp', 'true');
            });
        }

        //Check if first visit and Cookie modal has been closed before
        if (sessionStorage.getItem('confirmedHcp') != 'true' && document.cookie.includes("OptanonAlertBoxClosed") && location.search.indexOf('ed=1') < 0) {
            openHcpModal();
        }
        else {
            // observe when cookie modal is closed
            const targetNode = document.querySelector('body');

            const config = { attributes: true };

            const callback = (mutationList, observer) => {
                for (const mutation of mutationList) {
                    if (mutation.type === 'attributes') {
                        if (sessionStorage.getItem('confirmedHcp') != 'true' && document.cookie.includes("OptanonAlertBoxClosed") && location.search.indexOf('ed=1') < 0) {
                            openHcpModal();
                        }
                    }
                }
            };

            const observer = new MutationObserver(callback);

            observer.observe(targetNode, config);
        }
    });
};
